import { useEffect, useRef, useState } from 'react';
import { useAccountClient } from 'client/client-hook';
import useAuth from 'hooks/useAuth';
import { OpenTradeAccount, findAccountsWithOpenTrades } from './openTrades';

/**
 * Accounts with open copied trades, checked once the first time `active` turns on. Advisory only: a failed
 * check never blocks the pause; `unchecked` names the accounts whose own check failed, and `failed` means
 * the account list itself could not be read.
 */
export function useOpenTradeAccounts(active: boolean) {
  const { user } = useAuth() as any;
  const userId: string = user?.tcId || '';
  const getAccountClient = useAccountClient();
  const latestClient = useRef(getAccountClient);
  latestClient.current = getAccountClient;
  const [state, setState] = useState<{ checked: boolean; failed: boolean; accounts: OpenTradeAccount[]; unchecked: OpenTradeAccount[] }>({
    checked: false,
    failed: false,
    accounts: [],
    unchecked: []
  });
  const started = useRef(false);

  useEffect(() => {
    if (!active || !userId || started.current) return;
    started.current = true;
    (async () => {
      try {
        const { found, unchecked } = await findAccountsWithOpenTrades(await latestClient.current(), userId);
        setState({ checked: true, failed: false, accounts: found, unchecked });
      } catch {
        setState({ checked: true, failed: true, accounts: [], unchecked: [] });
      }
    })();
  }, [active, userId]);

  return { loading: active && !state.checked, failed: state.failed, accounts: state.accounts, unchecked: state.unchecked };
}
